<template>
  <div class="card card-profile">
    <img
      :src="gallery.images_url[0]"
      alt="Image placeholder"
      class="card-img-top"
    />
    <div class="card-body pt-0">
      <div class="text-left mt-4">
        <h5>{{ gallery.title }}</h5>
        <div class="h6 font-weight-300">{{ gallery.description }}</div>
      </div>
      <div
        class="
          d-flex
          flex-row
          bd-highlight
          align-items-center
          justify-content-end
        "
      >
      <!-- <button
            class="btn btn-link text-danger text-gradient px-3 m-0"
            @click="deleteGalery"
          >
            <i class="far fa-trash-alt me-2" aria-hidden="true"></i>
            Eliminar
          </button> -->

        <div class="bd-highlight">
          <router-link
            :to="`/gallery-card/${gallery.id}`"
            class="btn btn-link text-dark px-3 m-0"
          >
            <i class="fas fa-pencil-alt text-dark me-2" aria-hidden="true"></i
            >Editar
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "galleries-table",
  props: {
    gallery: {
      type: Object,
      required: true,
    },
  },
  methods: {
    deleteGalery() {
      this.plain
        .delete(`/galleries/${this.gallery.id}`)
        .then(() => {
          this.$parent.deleteItemGallery(this.gallery.id);
        })
        .catch((error) => {
          console.log("Error al eliminar GALLERY", error);
        });
    },
  },
};
</script>